import { useMemo, useState } from "react";

import Editor from "@/design/components/Editor";
import EditorList from "@/design/components/EditorList";
import EditorSidebar from "@/design/components/EditorSidebar";
import InputPhone from "@/design/forms/InputPhone";
import Valkyrie, { viPlus } from "@sippy-platform/valkyrie";

import { Box, Button, InputAdornment, Typography } from "@mui/material";
import PropTypes from "prop-types";

import PrefixButton from "./PrefixButton";
import PrefixForm from "./PrefixForm";

function PrefixEditor({ outboundRule, outboundDispatch }) {
  const [activePrefix, setActivePrefix] = useState(null);
  const [tester, setTester] = useState("");

  const destinations = useMemo(() => {
    if (tester === "") {
      return outboundRule.destinationPrefixes;
    } else {
      // Check if we start with 2 zeros, otherwise check for 1 zero
      const _tester = tester.startsWith("00")
        ? tester.replace("00", "+")
        : tester.startsWith("0")
          ? tester.replace("0", "+32")
          : tester;
      const result = outboundRule.destinationPrefixes
        .reverse()
        .find((destination) => _tester.includes(destination.destinationPrefix));
      return result ? [result] : [];
    }
  }, [outboundRule.destinationPrefixes, tester]);

  return (
    <Editor
      title="Destination prefixes"
      id="ruleEditorCard"
      controls={
        <InputPhone
          id="tester"
          label="Type to test a number"
          onChange={(_, value) => setTester(value)}
          value={tester || ""}
          sx={{ mt: 2 }}
          slotProps={{
            input: {
              startAdornment: <InputAdornment position="start">{outboundRule.prefix}</InputAdornment>,
            },
          }}
        />
      }
      actions={
        <Button
          variant="contained"
          startIcon={<Valkyrie icon={viPlus} />}
          onClick={() =>
            setActivePrefix({
              destinationPrefix: "",
              callerId: null,
            })
          }
        >
          Add
        </Button>
      }
    >
      <Box>
        <EditorList columns={1} direction="row">
          {destinations.length >= 1 ? (
            destinations.map((prefix) => (
              <PrefixButton
                key={prefix.id}
                outboundRule={outboundRule}
                prefix={prefix}
                activePrefix={activePrefix}
                setActivePrefix={setActivePrefix}
                outboundDispatch={outboundDispatch}
              />
            ))
          ) : tester ? (
            <Typography>No destination prefixes matches with your test query.</Typography>
          ) : (
            <Typography>No destination prefixes in this outbound rule.</Typography>
          )}
        </EditorList>
      </Box>
      <EditorSidebar showForm={!!activePrefix}>
        <PrefixForm
          key={activePrefix?.id}
          prefix={activePrefix}
          outboundRule={outboundRule}
          outboundDispatch={outboundDispatch}
          setActivePrefix={setActivePrefix}
        />
      </EditorSidebar>
    </Editor>
  );
}

PrefixEditor.propTypes = {
  outboundRule: PropTypes.object,
  outboundDispatch: PropTypes.func,
};

export default PrefixEditor;
